import React, { useEffect, useState, useContext } from "react";
import { Autocomplete, TextField } from "@mui/material";
import Button from "@mui/material/Button";
import logo from "../../images/logo.png";
import moment from "moment";
import DeleteIcon from "@mui/icons-material/Delete";
import ReactToPrint, { PrintContextConsumer } from "react-to-print";
import { API_URL } from "../../Global";
import axios from "axios";
import { toast } from "react-toastify";
import { FilterContext } from "./../../App";
import "../../App.css";

const Quote = (props) => {
    const { currentType, currentCompany } = useContext(FilterContext);

    // Form data
    // const [formData, setFormData] = useState({
    //     date: moment(new Date()).format("YYYY-MM-DD"),
    // });

    const [quotId, setQuotId] = useState(null);
    const [items, setItems] = useState([]);
    const [products, setProducts] = useState(null);

    const [saveFlag, setSaveFlag] = useState(false);
    const [grandTotal, setGrandTotal] = useState(0);
    const [currentPrice, setCurrentPrice] = useState(0);
    // const [currentType, setCurrentType] = useState(filterContext.currentType);
    // const [currentCompany, setCurrentCompany] = useState(props.currentCompany);

    const [currentProduct, setCurrentProduct] = useState("");
    const [currentUnit, setCurrentUnit] = useState("Sq.ft.");
    const [currentUnitPrice, setCurrentUnitPrice] = useState(0);
    const [currentWidth, setCurrentWidth] = useState(1);
    const [currentHeight, setCurrentHeight] = useState(1);
    const [currentSqft, setCurrentSqft] = useState(1);
    const [currentQuantity, setCurrentQuantity] = useState(1);
    const [companyFlag, setCompanyFlag] = useState(0);

    // ###################----SATISH KUMAR CHANGES----#####################----START----#######################
    const initialValue = {
        name: '',
        address: '',
        mobileNo: '',
        date: moment(new Date()).format("YYYY-MM-DD"),
        gstNumber: ''
    }
    const [formData, setFormData] = useState(initialValue);
    const [partyList, setPartyList] = useState([])
    const [selectUnit, setSelectUnit] = useState('Sq.ft.')
    // ###################----SATISH KUMAR CHANGES----#####################----END----#######################

    const [printComponentRef, setPrintComponentRef] = useState(null);

    const [date, setDate] = useState(moment(new Date()).format("YYYY-MM-DD"));

    // dueDate: ,
    // console.log(formData);

    // setDate(moment(new Date()).format("YYYY-MM-DD"))

    const Unit = [{ label: "Sq.ft." }, { label: "Inch" }, { label: "MM" }];

    // delete
    const deleteItem = (id) => {
        console.log("clicked" + id);

        setItems((oldItems) => {
            return oldItems.filter((arrElem, index) => {
                if (index == id) {
                    setGrandTotal(Number(grandTotal) - Number(arrElem.price));
                }
                return index !== id;
            });
        });
    };



    const listOfItems = () => {
        // update grand total
        setGrandTotal(Number(grandTotal) + Number(currentPrice));

        let multiplier =
            currentUnit === "Sq.ft." ? 1 : currentUnit === "Inch" ? 12 : 305;

        setItems((oldData) => {
            return [
                ...oldData,
                {
                    product: currentProduct,
                    unit: currentUnit,
                    unitPrice: currentUnitPrice,
                    quantity: currentQuantity,
                    width: currentWidth,
                    height: currentHeight,
                    sqft: currentSqft,
                    price: currentPrice,
                },
            ];
        });
        if (currentCompany == 1 && companyFlag == 0) {
            setCompanyFlag(1);
        } else if (currentCompany == 2 && companyFlag == 0) {
            setCompanyFlag(2);
        } else {
            setCompanyFlag(3);
        }
    };

    const updateCurrentPrice = (type, value) => {
        let divisor =
            currentUnit === "Sq.ft." ? 1 : currentUnit === "Inch" ? 144 : 92903;

        if (type === "unit") {
            setCurrentUnit(value);
            let divisor =
                value === "Sq.ft." ? 1 : value === "Inch" ? 144 : 92903;
            setCurrentPrice(
                (
                    (currentWidth *
                        currentHeight *
                        currentUnitPrice *
                        currentQuantity) /
                    divisor
                ).toFixed(2)
            );
        } else if (type === "unitPrice") {
            setCurrentUnitPrice(value);
            setCurrentPrice(
                (
                    (currentWidth * currentHeight * value * currentQuantity) /
                    divisor
                ).toFixed(2)
            );
        } else if (type === "quantity") {
            setCurrentQuantity(value);
            setCurrentPrice(
                (
                    (currentWidth * currentHeight * currentUnitPrice * value) /
                    divisor
                ).toFixed(2)
            );
        } else if (type === "product") {
            setCurrentUnitPrice(value);
            setCurrentPrice(
                (
                    (currentWidth * currentHeight * value * currentQuantity) /
                    divisor
                ).toFixed(2)
            );
        } else if (type === "width") {
            setCurrentWidth(value);

            setCurrentPrice(
                (
                    (value *
                        currentHeight *
                        currentUnitPrice *
                        currentQuantity) /
                    divisor
                ).toFixed(2)
            );
        } else if (type === "height") {
            setCurrentHeight(value);
            setCurrentPrice(
                (
                    (currentWidth *
                        value *
                        currentUnitPrice *
                        currentQuantity) /
                    divisor
                ).toFixed(2)
            );
        }
        updateSqft(type, value);
    };

    const updateSqft = (type, value) => {
        let multiplier =
            currentUnit === "Sq.ft." ? 1 : currentUnit === "Inch" ? 144 : 92903;
        if (type === "width") {
            setCurrentSqft(
                (
                    ((value * currentHeight) / multiplier) *
                    currentQuantity
                ).toFixed(2)
            );
        } else if (type === "height") {
            setCurrentSqft(
                (
                    ((currentWidth * value) / multiplier) *
                    currentQuantity
                ).toFixed(2)
            );
        } else if (type === "unit") {
            let multiplier =
                value === "Sq.ft." ? 1 : value === "Inch" ? 144 : 92903;
            setCurrentSqft(
                (
                    ((currentWidth * currentHeight) / multiplier) *
                    currentQuantity
                ).toFixed(2)
            );
        } else if (type === "quantity") {
            setCurrentSqft(
                (((currentWidth * currentHeight) / multiplier) * value).toFixed(
                    2
                )
            );
        }
    };

    // fetching data
    const fetchProductList = () => {
        let url = API_URL;
        // const query = `SELECT CONCAT(id, ', ', name) AS name, address FROM party;`;
        const query = `select id, name as label, price from products where status = 1 and customerType = ${currentType} and company = ${currentCompany} order by name asc`;
        let data = { crossDomain: true, crossOrigin: true, query: query };
        axios
            .post(url, data)
            .then((res) => {
                setProducts(res.data);
            })
            .catch((err) => {
                console.log("products fetch error: ", err);
            });
    };
    useEffect(() => {
        fetchProductList();
    }, [currentType, currentCompany]);

    // insert bill list
    const insertQuotList = (quotId) => {
        let url = API_URL;

        // 1.  insert into deliveryMemoList
        items.map((item, index) => {
            const query = `INSERT INTO billList(billType, billId, particular, quantity, rate, width, height, sqft, amount) VALUES(
          3,
          ${quotId},
          '${item.product}', 
          ${item.quantity}, 
          ${(item.price / item.sqft).toFixed(2)},
          ${item.width},
          ${item.height},
          ${item.sqft},
          ${item.price}
        )`;
            let data = { crossDomain: true, crossOrigin: true, query: query };
            axios
                .post(url, data)
                .then((res) => {
                    console.log("insertBillList successfull, index: ", index);
                })
                .catch((err) => {
                    console.log("failed to insertBillList, error: ", err);
                });
        });
    };

    // console.log((formData.date == null
    //     ? moment(new Date()).format(
    //           "D/M/YYYY"
    //       )
    //     : moment(formData.date).format(
    //           "D/M/YYYY"
    //       )))

    // save QUOT
    const saveQuot = () => {
        const newCDate =
            formData.date == null
                ? moment(new Date()).format("YYYY-M-D")
                : moment(formData.date).format("YYYY-M-D");
        console.log(newCDate);
        let query;

        query = `INSERT INTO quotation (quotNumber, partyName, mobileNo, address, date, total,companyType) values(
            "${moment(new Date()).format("MMMYY/DD/hmmss").toUpperCase()}",
                "${formData.name}",
           "${formData.mobileNo}",
           "${formData.address}",
           "${newCDate}",
           ${grandTotal},
       ${companyFlag}

            )`;
        console.log(query);
        let data = { crossDomain: true, crossOrigin: true, query: query };
        axios
            .post(API_URL, data)
            .then((res) => {
                toast.success("Quot. generated successfully");
                setQuotId(res.data.insertId);
                insertQuotList(res.data.insertId);
            })
            .catch((err) => {
                toast.error("Failed to Generate Quot ");
            });
    };



    // ###################---SATISH KUMAR CHANGES----##################----START----############################
    const [userSelect, setUserSelect] = useState()

    const fetchAllPartyList = async () => {
        let url = API_URL;
        const query = `SELECT name, address, mobile as mobileNo FROM party`;
        let data = { crossDomain: true, crossOrigin: true, query: query };
        const response = await axios.post(url, data)
        if (response.status === 200) {
            return setPartyList(response.data)
        } else {
            return []
        }
    }

    useEffect(() => {
        fetchAllPartyList()
    }, [])

    useEffect(() => {
        if (userSelect === null || userSelect === undefined) {
            setFormData(initialValue)
        } else {
            setFormData({
                ...formData,
                ...userSelect
            })
        }
    }, [userSelect])
    // ###################---SATISH KUMAR CHANGES----##################----END----############################



    return (
        <div className="">
            <div className="form mt-4 mb-0">
                <div className="inputesC1 d-flex flex-wrap mb-2">
                    {/* <TextField
                        id="outlined-basic"
                        onChange={(e) =>
                            setFormData({
                                ...formData,
                                name: e.target.value,
                            })
                        }
                        required="true"
                        size="small"
                        label="Name"
                        className="inputField "
                        name="Name"
                        type="text"
                        variant="outlined"
                    /> */}

                    {/* ###################---SATISH KUMAR CHANGES----##################----START----############################ */}
                    <Autocomplete
                        // fullWidth
                        id="free-solo-demo"
                        size='small'
                        options={partyList}
                        className="inputField  mx-2"
                        value={userSelect}
                        getOptionLabel={value => `${value.name}`}
                        noOptionsText="Name not found"
                        onChange={(event, newValue) => setUserSelect(newValue)}
                        renderInput={(params) => <TextField size='small' placeholder='Select a name' sx={{ width: '100%' }} {...params} label='Name' />}
                    />
                    {/* ###################---SATISH KUMAR CHANGES----##################----END----############################ */}

                    <TextField
                        id="standard-basic"
                        onChange={(e) =>
                            setFormData({
                                ...formData,
                                address: e.target.value,
                            })
                        }
                        required="true"
                        value={formData.address}
                        size="small"
                        label="Address"
                        className="inputField  mx-2"
                        name="address"
                        type="text"
                        variant="standard"
                    />

                    <TextField
                        id="outlined-basic"
                        onChange={(e) =>
                            setFormData({
                                ...formData,
                                mobileNo: e.target.value,
                            })
                        }
                        required="true"
                        size="small"
                        label="Mobile No."
                        value={formData.mobileNo}
                        type="tel"
                        className="inputField  mx-2"
                        name="MObile No."
                        variant="outlined"
                    />
                    <TextField
                        id="outlined-basic"
                        format="MM/DD/YYY"
                        onChange={(e) =>
                            setFormData({
                                ...formData,
                                date: e.target.value,
                            })
                        }
                        size="small"
                        type="date"
                        value={formData.date}
                        // options={products != null ? products : []}
                        views="                     "
                        className="inputField  mx-2"
                        name="Date"
                        variant="outlined"
                    />


                    <TextField
                        id="outlined-basic"
                        size="small"
                        label="GST Number"
                        type="text"
                        className="inputField  mx-2"
                        name="gstNumber"
                        value={formData.gstNumber}
                        variant="outlined"
                        required="true"
                        onChange={(e) =>
                            setFormData({
                                ...formData,
                                gstNumber: e.target.value,
                            })
                        }
                        style={{ width: "200px" }}
                    />


                    {/* <TextField
                    id="Date"
                    label="Date"
                    // variant="outlined"
                    className="mr-2"
                    // value={this.state.dueDate}
                    // onChange={(e) => this.setState({ dueDate: e.target.value })}
                    // required="true"
                    size="small"
                    type="date"
                    // style={{ width: "180px" }}
                /> */}
                </div>
                <hr />
                <div>
                    <button className="btn btn-sm btn-danger px-5 pt-2">
                        <h6>{["Mediator", "Retailer"][currentType - 1]}</h6>
                    </button>
                </div>
                <div className="  inputes2 mt-2 mb-4 ">
                    <Autocomplete
                        id="free-solo-demo"
                        className="inputFieldp      "
                        options={products != null ? products : []}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                // label="party name"
                                label="Product"
                                variant="outlined"
                                size="small"
                            />
                        )}
                        onChange={(event, value) => {
                            if (value != null) {
                                // console.log(value.price);
                                setCurrentProduct(value.label);
                                updateCurrentPrice("product", value.price);
                            }
                        }}
                    />
                    <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={Unit}
                        className="inputField  mx-2"
                        size="small"
                        sx={{ width: 10 }}
                        // style={{ width: "150px" }}
                        renderInput={(params) => (
                            <TextField {...params} label="Unit" />
                        )}
                        defaultValue="Sq.ft."
                        onChange={(event, value) => {
                            if (value != null) {
                                updateCurrentPrice("unit", value.label);
                            }
                        }}
                    />

                    <TextField
                        id="unitPrice"
                        label="Unit Price / sq.ft."
                        variant="outlined"
                        size="small"
                        className="inputField  px-2"
                        sx={{ width: 150 }}
                        // md={{ width: 100 }}

                        // style={{ width: "130px" }}
                        value={currentUnitPrice}
                    />
                    <TextField
                        id="outlined-basic"
                        // value={34}
                        size="small"
                        label="Width"
                        className="inputField  px-2"
                        name="width"
                        type="number"
                        variant="outlined"
                        // style={{ width: "100px" }}
                        value={currentWidth}
                        onChange={(e) => {
                            updateCurrentPrice("width", e.target.value);
                        }}
                    />
                    <TextField
                        id="outlined-basic"
                        // value={34}
                        size="small"
                        label="Height"
                        className="inputField  px-2"
                        name="height"
                        type="number"
                        variant="outlined"
                        // style={{ width: "100px" }}
                        value={currentHeight}
                        onChange={(e) => {
                            updateCurrentPrice("height", e.target.value);
                        }}
                    />
                    <TextField
                        id="outlined-basic"
                        // value={34}
                        size="small"
                        label="Quantity"
                        className="inputField  px-2"
                        name="quantity"
                        type="number"
                        variant="outlined"
                        // style={{ width: "100px" }}
                        value={currentQuantity}
                        onChange={(e) => {
                            updateCurrentPrice("quantity", e.target.value);
                        }}
                    />

                    <TextField
                        id="sqft"
                        size="small"
                        label="Sq.ft."
                        className="inputField  px-2"
                        name="sqft"
                        variant="outlined"
                        // style={{ width: "150px" }}
                        value={currentSqft}
                        readOnly
                    />

                    <TextField
                        id="price"
                        size="small"
                        label="Price"
                        className="inputField  px-2"
                        name="Price"
                        type="number"
                        variant="outlined"
                        // style={{ width: "150px" }}
                        value={currentPrice}
                        onChange={(e) => {
                            setCurrentPrice(e.target.value);
                        }}
                    />

                    <Button
                        variant="contained"
                        className="AddButtons "
                        onClick={listOfItems}
                        disabled={
                            !formData.address ||
                            !formData.name ||
                            !formData.mobileNo
                        }
                    >
                        Add
                    </Button>
                </div>
            </div>

            {/* Overview */}

            <div
                className="ReceptContainer"
                ref={(el) => setPrintComponentRef(el)}
            >
                <div className="text-center">
                    <div className="header  ReceptBg ">
                        <div class="row logoContainer ">
                            <div class="col-sm-12  col-md-6 text-start ">
                                <img
                                    src={logo}
                                    alt="logo"
                                    className="img-fluid"
                                />
                            </div>

                            <div class="col-sm-12  col-md-6 ">
                                <p className="py-3 pl-4 text-start">
                                    Shop No.2, vithoba Complex, Sangli-Miraj
                                    Road <br /> Nr.Parshwanthnagar Bus Stop,
                                    Miraj - 416 410 (Maha) <br /> Mobile:
                                    7293242424, e-mail:
                                    imprint24.india@gmail.com
                                </p>
                            </div>
                        </div>
                    </div>
                    <h5 className="bg-secondary text-white px-2">QUOTATION</h5>
                    <div className="p-2 text-start">
                        <div className="row">
                            <div className="col-6">
                                <p className="text-start">
                                    Party Name: &nbsp; {formData.name}{" "}
                                </p>
                            </div>
                            <div className="col-6">
                                <p> Phone No: &nbsp;{formData.mobileNo} </p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-6">
                                <p>Address: &nbsp; {formData.address} </p>
                            </div>
                            <div className="col-6">
                                <p>
                                    Date :
                                    <b>
                                        {formData.date == null
                                            ? moment(new Date()).format(
                                                "D/M/YYYY"
                                            )
                                            : moment(formData.date).format(
                                                "D/M/YYYY"
                                            )}
                                    </b>
                                </p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-6">
                                <p>
                                    Quot Number :{" "}
                                    <b>
                                        {moment(new Date())
                                            .format("MMMYY/DD/hmmss")
                                            .toUpperCase()}
                                    </b>
                                </p>
                            </div>

                            <div className="col-6">
                                <p>
                                    GST Number :&nbsp;
                                    {formData.gstNumber}
                                </p>
                            </div>

                        </div>
                    </div>
                    <h6 className="bg-secondary text-secondary px-2">.</h6>

                    <table>
                        <tr className="titles">
                            <th className="text-start">Sr. No.</th>
                            <th className="text-start">Product</th>
                            <th className="text-center">Quantity</th>
                            <th className="text-center">Rate / sq.ft.</th>
                            <th className="text-center">W/H</th>
                            <th className="text-center">Unit</th>
                            <th className="text-center">Sq. ft.</th>

                            <th className="text-center">Total</th>
                            <th className="d-print-none text-center">Action</th>
                        </tr>

                        {items.map((item, id) => {
                            return (
                                <tr key={id}>
                                    <td className="text-start">{id + 1}</td>
                                    <td className="text-start">{item.product}</td>
                                    <td className="text-center">{item.quantity}</td>
                                    <td className="text-center">
                                        {(item.price / item.sqft).toFixed(2)}
                                    </td>
                                    <td className="text-center">{item.width + " X " + item.height}</td>
                                    <td className="text-center">{item.unit}</td>
                                    <td className="text-center">{item.sqft}</td>

                                    <td className="text-center">{Number(item.price).toFixed(2)}</td>
                                    <td className="d-print-none text-center">
                                        <span onClick={() => deleteItem(id)}>
                                            {" "}
                                            <DeleteIcon color="error" />{" "}
                                        </span>
                                    </td>
                                </tr>
                            );
                        })}

                        <br />
                        <tr></tr>
                        <tr>
                            <td colSpan={7}>
                                <b>Grand Total</b>
                            </td>
                            <td className="text-center">
                                <b>{grandTotal.toFixed(2)}</b>
                            </td>
                        </tr>

                        {/* <tr>
                            <td>
                              <h1>hey</h1>
                            </td>
                        </tr> */}
                    </table>
                    <hr />
                    <div className="row">
                        <div className="col-4 col-md-4">
                            <h6
                                style={{
                                    textTransform: "capitalize",
                                }}
                            >
                                GST No.: <b>27EMNPP2479H1ZD</b>
                            </h6>
                        </div>
                        <div className="col-6 col-md-4">
                            <img
                                src="/Assets/QrCode1.jpg"
                                height="100"
                                width="100"
                            />
                        </div>
                        <div className="col-4 col-md-4"></div>
                    </div>
                </div>
            </div>

            {/* invoice */}

            <ReactToPrint content={() => printComponentRef}>
                <PrintContextConsumer>
                    {({ handlePrint }) => (
                        <Button
                            onClick={handlePrint}
                            className="mb-5 mt-0 mr-3"
                            color="primary"
                            variant="contained"
                            style={{ float: "right" }}
                            disabled={saveFlag == true ? false : true}
                        >
                            PRINT
                        </Button>
                    )}
                </PrintContextConsumer>
            </ReactToPrint>
            {/* save Quot */}
            <Button
                className=" mr-3"
                color="secondary"
                variant="contained"
                style={{ float: "right", marginRight: "20px" }}
                // type="submit"
                onClick={(e) => {
                    setSaveFlag(true);
                    saveQuot();
                }}
                disabled={
                    !formData.address || !formData.name || !formData.mobileNo
                }
            >
                SAVE QUOT
            </Button>
        </div>
    );
};

export default Quote;
